import StackManager from "models/stack_manager"

export default function(stackName) {
  const stackManager = StackManager.loadFor(stackName)

  return stackManager
}
